<template>
    <div>{{ row.week.end | date('MM/DD/YYYY') }}</div>
</template>

<script>
export default {
    props: ['row'],
};
</script>
